var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"themeBody",attrs:{"data-theme":_vm.themeMode}},[(_vm.$store.state.isInSlicer == true)?_c('go-back-button',{staticClass:"policiesGoBackButton",attrs:{"is-align-center":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._v("\n      用户协议\n    ")]},proxy:true}],null,false,3088180435)}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.articleContent)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a665f0","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/policies/terms.vue
// module id = 353
// module chunks = 0